import { create } from 'zustand';
import { IExportState, StateType } from '@/version-types';
import { getState, useState } from '../index';

/** 存储类型 */
interface IStore {
    /** 加载图层映射 */
    loadingMap: Record<string, string[]>;
    /** 添加加载图层 */
    addLoading(layerId: string, extraInfo?: string): void;
    /** 移除加载图层 */
    removeLoading(layerId: string, extraInfo?: string): void;
    /** 检查是否加载 */
    checkIsLoading(layerId: string): boolean;
    /** 销毁 */
    destroy: () => void;
}

/** 创建存储 */
const createState = (identity: string) => {
    return create<IStore>((set, get) => ({
        destroy() {
            set({ loadingMap: {} });
        },

        loadingMap: {},
        addLoading(layerId: string, extraInfo?: string) {
            let data = get().loadingMap[layerId] || [];
            if (extraInfo) {
                data.push(extraInfo);
                data = Array.from(new Set(data));
            }
            set({ loadingMap: { ...get().loadingMap, [layerId]: data } });
        },
        removeLoading(layerId: string, extraInfo?: string) {
            let data = get().loadingMap[layerId] || [];
            if (extraInfo) {
                data = data.filter((info) => info !== extraInfo);
            }
            if (data.length === 0) {
                delete get().loadingMap[layerId];
                set({ loadingMap: { ...get().loadingMap } });
            } else {
                set({ loadingMap: { ...get().loadingMap, [layerId]: data } });
            }
        },
        checkIsLoading(layerId: string) {
            const loadingMap = get().loadingMap;
            return !!loadingMap[layerId];
        },
    }));
};

/** 存储名称 */
const name = 'loading-layer-state';

/** 存储类型 */
type ModuleType = StateType<IStore, typeof name>;

/** hook 获取 id */
export const useLoadingState = () => {
    return useState<ModuleType>()[name];
};

/** 通过 id 获取存储 */
export const getLoadingState = (identity: string) => {
    return getState<ModuleType>(identity)[name].getState();
};

/** 导出存储 */
export default {
    name,
    createState,
} as IExportState;
